(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  class CustomFaq extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('.custom-faq__item').forEach((item) => {
        const btn = item.querySelector('.custom-faq__question');
        const answer = item.querySelector('.custom-faq__answer');
        if (!btn) return;
        btn.addEventListener('click', () => this.toggle(item, btn, answer));
      });
    }
    toggle(item, btn, answer) {
      const willOpen = !item.classList.contains('is-open');
      item.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (answer) answer.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
    }
  }
  if (!customElements.get('custom-faq')) {
    customElements.define('custom-faq', CustomFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class CustomReviewsCarousel extends HTMLElement {
    constructor() {
      super();
      this.viewport = this.querySelector('[data-viewport]');
      this.prev = this.querySelector('[data-direction="prev"]');
      this.next = this.querySelector('[data-direction="next"]');
      if (!this.viewport) return;
      if (this.prev) this.prev.addEventListener('click', () => this.scrollByCard(-1));
      if (this.next) this.next.addEventListener('click', () => this.scrollByCard(1));
      this.viewport.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons(), { passive: true });
      this.updateButtons();
    }
    scrollByCard(direction) {
      const card = this.viewport.querySelector('.custom-reviews__card');
      const styles = getComputedStyle(this.viewport.querySelector('.custom-reviews__track'));
      const gap = parseInt(styles.gap, 10) || 16;
      const step = card ? card.getBoundingClientRect().width + gap : this.viewport.clientWidth * 0.8;
      this.viewport.scrollBy({ left: step * direction, behavior: 'smooth' });
    }
    updateButtons() {
      if (!this.prev || !this.next) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.viewport;
      this.prev.toggleAttribute('disabled', scrollLeft <= 1);
      this.next.toggleAttribute('disabled', scrollLeft + clientWidth >= scrollWidth - 1);
    }
  }
  if (!customElements.get('custom-reviews-carousel')) {
    customElements.define('custom-reviews-carousel', CustomReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
